import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/pages/Home.vue';
import ShowEnterprise from '@/views/pages/pub/enterprises/Show.vue';
import EnterprisesIndex from '@/views/pages/pub/enterprises/Index.vue';
import EnterpriseProduct from '@/views/pages/pub/enterprises/products/Show.vue';
import store from '../store';
import staticPages from './static';
import work, { WORK } from '@/router/work';
import Index from '@/views/pages/auth/work/Index.vue';

Vue.use(VueRouter);

export const ifNotAuthenticated = (to:any, from:any, next:any) => {
  return next(store.getters.isAuthenticated);
};

export const ifAuthenticated = (to:any, from:any, next:any) => {
  if (store.getters.isAuthenticated) {
    return next();
  }
  return next('/');
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/enterprises',
    name: 'enterprises.index',
    component: EnterprisesIndex
  },
  {
    path: '/enterprises/:enterprise',
    name: 'enterprises.show',
    component: ShowEnterprise,
    children: [
      {
        path: 'products/:product',
        name: 'enterprises.products.show',
        component: EnterpriseProduct
      }
    ]
  },
  {
    path: '/work',
    name: WORK,
    component: Index,
    meta: {
      title: 'Розділ: Робота'
    },
    beforeEnter: ifAuthenticated
  },
  ...work,
  ...staticPages
];

const router = new VueRouter({
  routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});

export default router;
